import { Capability } from '@metservicedev/cf-units/dist/units/units';

import { DatasetData } from '../WidgetBlocks/SingleCurrentValue/types';
import { coordinatesToRadianAndMagnitude } from './coordinatesToAngleAndMagnitude';

const dataPoint = (datum: DatasetData, capability: Capability, inRadians = false) => {
    if (!datum) {
        return null;
    }

    const { data_type, variables } = capability;

    if (data_type === 'vector' && Object.keys(variables).length === 2) {
        const { x, y } = Object.keys(variables).reduce<{ x: number | null; y: number | null }>(
            (vectorXY, variableId) => {
                const axis = variables[variableId]!.attributes.axis!.toLowerCase(); //'x' | 'y'
                const value = datum[variableId];

                return { ...vectorXY, [axis]: value };
            },
            { x: null, y: null }
        );

        if (x === null || y === null) {
            return null;
        }

        const { magnitude, radians } = coordinatesToRadianAndMagnitude({ x, y });

        return inRadians ? radians : magnitude;
    }

    const variable = Object.keys(variables)[0];

    return datum[variable];
};

export default dataPoint;
